export enum PriceRateSearchExplainMode {
  Save = "save",
  Recalculate = "recalculate",
  Produce = "produce",
}
